import { buildColorGradient } from 'spw-projects/project-profile/space-categories-and-colors/utils';
import {
  IProjectColors,
  ProjectStatus,
  UserRoleInProject,
} from 'spw-redux/modules/projects/types';
import { ProgramSummaryView } from 'spw-redux/modules/program-summary/programming/types';
import { Category } from 'spw-redux/modules/space_types/types';
import {
  CalculatorType,
  IWorksheetRowValue,
} from 'spw-redux/modules/calculators/types';
import { DefaultSpaceTypeCategory } from './models/space-category';

export const INSERT_FLOOR_ABOVE_TEXT = 'Insert a new floor above';
export const INSERT_FLOOR_BELOW_TEXT = 'Insert a new floor below';
export const EDIT_FLOOR_NAME_TEXT = 'Edit name';
export const MOVE_FLOOR_UP_TEXT = 'Move floor up';
export const MOVE_FLOOR_DOWN_TEXT = 'Move floor down';
export const DELETE_FLOOR_TEXT = 'Delete floor';
export const REPLACE_FLOOR_PLAN_TEXT = 'Replace floor plan';
export const EXISTING_SITE_ANALYSIS = 'existing_site_analysis';
export const PROGRAMMING = 'programming';
export const DEFAULT_CITY = 'City';
export const DEFAULT_STREET_ADDRESS = 'Street Address';
export const DEFAULT_STATE = 'State';
export const SEAT_COUNTS = {
  meetingSpaces: 'Seats',
  individualWorkspaces: 'Work Seats',
  amenitySpaces: 'Seats',
  supportSpaces: 'Seats',
  undefined: 'Seats',
};
export const CUSTOM_PREFIX = 'custom';
export const SHARED_SPACES_CATEGORY = 'sharedSpaces';
// TODO: Remove duplicate constant
export const INDIVIDUAL_SPACES_CATEGORY = 'individualWorkspaces';
export const INDIVIDUAL_WORKSPACES_CATEGORY = 'individualWorkspaces';
export const WORKSTATIONS_SUBCATEGORY = 'workstations';
export const PRIVATE_OFFICES_SUBCATEGORY = 'privateOffices';
export const CUSTOM_SUBCATEGORY = 'customSubcategory';
export const MEETING_SPACES_CATEGORY = 'meetingSpaces';
export const AMENITY_SPACES_CATEGORY = 'amenitySpaces';
export const SUPPORT_SPACES_CATEGORY = 'supportSpaces';
export const CUSTOM_CATEGORY = 'customCategory';
export const NOTE_GENERAL_CATEGORY = 'general';
export const BUILDING_DETAILS = 'buildingDetails';
export const ZOOM_DIFFERENTIAL = 7;
export const FLOORPLAN_IMAGE_BOUNDS_PADDING_PERCENTAGE = 0.25;
export const SPACES_MAX_BOUNDS_PADDING_PERCENTAGE = 0.2;
export const SELECTION_AUTO_PAN_PADDING_PIXELS = 20;
export const SPACE_TYPE_CATEGORIES = [
  INDIVIDUAL_SPACES_CATEGORY,
  CUSTOM_SUBCATEGORY,
  MEETING_SPACES_CATEGORY,
  AMENITY_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
  WORKSTATIONS_SUBCATEGORY,
  PRIVATE_OFFICES_SUBCATEGORY,
  CUSTOM_CATEGORY,
];
export const GENERAL_CATEGORY_TITLE = 'General Notes';
export const HOTEL_DESK_TYPE = 'hotel_desk';
export const PRIVATE_OFFICE_TYPE = 'private_office';
export const WORKSTATION_TYPE = 'workstation';
export const CUSTOM_WORKSPACE_TYPE = 'custom_workspace_type_child';
export const CUSTOM_OFFICE_TYPE = 'custom_office_type_child';
export const PARENT_CUSTOM_OFFICE_TYPE = 'custom_office_type';
export const PARENT_CUSTOM_WORKSPACE_TYPE = 'custom_workspace_type';
export const PARENT_CUSTOM_SUBCATEGORY_TYPE = 'custom_subcategory_space_type';
export const CUSTOM_SUBCATEGORY_SPACE_TYPE_CHILD =
  'custom_subcategory_space_type_child';
export const CUSTOM_MEETING_SPACE_CHILD = 'custom_meeting_space_child';
export const CUSTOM_AMENITY_SPACE_CHILD = 'custom_amenity_space_child';
export const CUSTOM_SUPPORT_SPACE_TYPE = 'custom_support_space_child';
export const SHARED_PRIVATE_OFFICE = 'shared_private_office';
export const EXECUTIVE_PRIVATE_OFFICE = 'executive_private_office';
export const PROJECTS_ROUTE = '/projects';

export const PRIVATE_OFFICE_SPACE_TYPES_MAP: {
  [spaceTypeId: string]: boolean;
} = {
  [PRIVATE_OFFICE_TYPE]: true,
  [EXECUTIVE_PRIVATE_OFFICE]: true,
  [SHARED_PRIVATE_OFFICE]: true,
  [PARENT_CUSTOM_OFFICE_TYPE]: true,
  [CUSTOM_OFFICE_TYPE]: true,
};

export const WORKSTATION_SPACE_TYPES_MAP: { [spaceTypeId: string]: boolean } = {
  [WORKSTATION_TYPE]: true,
  [CUSTOM_WORKSPACE_TYPE]: true,
  [HOTEL_DESK_TYPE]: true,
  [PARENT_CUSTOM_WORKSPACE_TYPE]: true,
};

export const TITLES = {
  BUILDING_SUMMARY: 'Building Summary',
  DEPARTMENT_SUMMARY: 'Department Summary',
  FLOOR_SUMMARY: 'Floor Summary',
  INDIVIDUAL_WORK_SPACES: 'Individual Workspaces',
  MEETING_SPACES: 'Meeting Spaces',
  AMENITY_SPACES: 'Amenity Spaces',
  SUPPORT_SPACES: 'Support Spaces',
  SHARED_SPACES: 'Shared Spaces',
  OTHER_SPACES: 'Other Spaces',
};

export const CUSTOM_WORKSPACE_COLORS = 'customWorkspaceColors';
export const CUSTOM_MEETING_SPACE_COLORS = 'customMeetingSpaceColors';
export const CUSTOM_AMENITY_SPACE_COLORS = 'customAmenitySpaceColors';
export const CUSTOM_SUPPORT_SPACE_COLORS = 'customSupportSpaceColors';
export const CUSTOM_CATEGORY_COLORS = 'customCategoryColors';
export const MEETING_SPACES_KEY = 'meetingSpaces';
export const AMENITY_SPACES_KEY = 'amenitySpaces';
export const SUPPORT_SPACES_KEY = 'supportSpaces';
export const OTHER_SPACES_KEY = 'otherSpaces';
export const SHARED_SPACES_KEY = 'sharedSpaces';

export const APP_HEADER_HEIGHT_IN_PX = 52;

const DEFAULT_WORKSPACE_COLOR = '#A967E8';
const DEFAULT_MEETING_SPACE_COLOR = '#40B6F9';
const DEFAULT_AMENITY_SPACE_COLOR = '#F58D8D';
const DEFAULT_SUPPORT_SPACE_COLOR = '#6FCF97';

export const CATEGORY_CUSTOM_COLORS_PARAMS: Record<
  Category,
  {
    swatchesRequired: number;
    categoryColorsKey: string;
  }
> = {
  [INDIVIDUAL_WORKSPACES_CATEGORY]: {
    categoryColorsKey: CUSTOM_WORKSPACE_COLORS,
    swatchesRequired: 8,
  },
  [MEETING_SPACES_CATEGORY]: {
    categoryColorsKey: CUSTOM_MEETING_SPACE_COLORS,
    swatchesRequired: 10,
  },
  [AMENITY_SPACES_CATEGORY]: {
    categoryColorsKey: CUSTOM_AMENITY_SPACE_COLORS,
    swatchesRequired: 10,
  },
  [SUPPORT_SPACES_CATEGORY]: {
    categoryColorsKey: CUSTOM_SUPPORT_SPACE_COLORS,
    swatchesRequired: 14,
  },
  [CUSTOM_CATEGORY]: { categoryColorsKey: '', swatchesRequired: 10 },
};

const DEFAULT_SELECT_GRADIENTS: { [color: string]: string[] } = {
  [DEFAULT_WORKSPACE_COLOR]: [
    '#D7B8F4', // Hotel Desk
    '#C395EF', // Workstation
    '#A967E8', // Custom Private Office
    '#9C4EE4', // Custom Workstation
    '#882ADF', // Private Office
    '#731DC3', // Exec Private Office
    '#5E18A0', // Shared Private Office
    '#AA68E8', // Custom subcategory
  ],
  [DEFAULT_MEETING_SPACE_COLOR]: [
    '#C0E7FD', // Open Collab
    '#90D4FC', // Huddle Room
    '#77CBFB', // Multi Purpose
    '#5EC2FA', // Phone Room
    '#46B8F9', // Small Conference
    '#40B6F9', // Custom Meeting Space
    '#12A5F8', // Training Room
    '#0798EA', // Med Conference
    '#0688D2', // XL Conference
    '#0478B9', // Large Conference
  ],
  [DEFAULT_AMENITY_SPACE_COLOR]: [
    '#F7A4A4', // Break Room
    '#F48989', // Cafe
    '#FBD1D1', // Fitness Room
    '#F59393', // Game Room
    '#FD8686', // Library
    '#FFB9B9', // Meditation Room
    '#EE8F8F', // Mother’s Room
    '#F9BBBB', // Pantry
    '#FAC6C6', // Wellness Room
    '#F58D8D', // [Custom Amenity Spaces] *
  ],
  [DEFAULT_SUPPORT_SPACE_COLOR]: [
    '#6FCF97', // ADA Bathroom
    '#D4F1E0', // Coat Closet
    '#BBEDD0', // Copy / Print Room
    '#7DD4A1', // IDF
    '#64BA88', // IT Storage Room
    '#A9E2C1', // IT Tech Bar
    '#8CD9AC', // Janitorial Closet
    '#51D889', // MDF
    '#C5ECD5', // Reception Desk & Seating
    '#49C27C', // Satellite Copy Area
    '#A5ECC3', // Storage Room
    '#70CF97', // [Custom Support Spaces] *
    '#9ADDB6', // File Cabinets
    '#33E07B', // Lockers
  ],
};

const prebuiltSelectedGradients = (baseColor: string): string[] =>
  DEFAULT_SELECT_GRADIENTS[baseColor];

export const DEFAULT_COLORS: IProjectColors = {
  [INDIVIDUAL_WORKSPACES_CATEGORY]: DEFAULT_WORKSPACE_COLOR,
  [MEETING_SPACES_KEY]: DEFAULT_MEETING_SPACE_COLOR,
  [AMENITY_SPACES_KEY]: DEFAULT_AMENITY_SPACE_COLOR,
  [SUPPORT_SPACES_KEY]: DEFAULT_SUPPORT_SPACE_COLOR,
  [SHARED_SPACES_KEY]: '#CBCBCB',
  [OTHER_SPACES_KEY]: '#CBCBCB',
  [CUSTOM_WORKSPACE_COLORS]: prebuiltSelectedGradients(DEFAULT_WORKSPACE_COLOR),
  [CUSTOM_MEETING_SPACE_COLORS]: prebuiltSelectedGradients(
    DEFAULT_MEETING_SPACE_COLOR
  ),
  [CUSTOM_AMENITY_SPACE_COLORS]: prebuiltSelectedGradients(
    DEFAULT_AMENITY_SPACE_COLOR
  ),
  [CUSTOM_SUPPORT_SPACE_COLORS]: prebuiltSelectedGradients(
    DEFAULT_SUPPORT_SPACE_COLOR
  ),
};

const presetColorSwatchAvailable = (color: string) =>
  [
    DEFAULT_WORKSPACE_COLOR,
    DEFAULT_MEETING_SPACE_COLOR,
    DEFAULT_AMENITY_SPACE_COLOR,
    DEFAULT_SUPPORT_SPACE_COLOR,
  ].includes(color);

export const presetColorGradientAvailable = (color: string) =>
  [
    DEFAULT_WORKSPACE_COLOR,
    DEFAULT_MEETING_SPACE_COLOR,
    DEFAULT_AMENITY_SPACE_COLOR,
    DEFAULT_SUPPORT_SPACE_COLOR,
  ].includes(color);

export const presetColorSwatch = (color: string): string[] => {
  if (!color) return [];
  switch (color) {
    case DEFAULT_WORKSPACE_COLOR:
      return [
        '#ECDDFA',
        '#E6D3F8',
        '#E0C8F7',
        '#DCC1F6',
        '#D7B8F4', // Hotel Desk
        '#CFA4F9',
        '#C395EF', // Workstation
        '#B47AEB',
        '#AA68E8',
        '#A967E8', // Custom Private Office
        '#9C4EE4', // Custom Workstation
        '#A057E6',
        '#9645E3',
        '#8C33E0',
        '#882ADF', // Private Office
        '#771FCC',
        '#731DC3', // Exec Private Office
        '#6319A8',
        '#5E18A0', // Shared Private Office
        '#54178F',
      ];
    case DEFAULT_MEETING_SPACE_COLOR:
      return [
        '#C0E7FD', // Open Collab
        '#BAE5FD',
        '#A6DDFC',
        '#90D4FC', // Huddle Room
        '#7ECEFB',
        '#77CBFB', // Multi Purpose
        '#6BC6FA',
        '#5EC2FA', // Phone Room
        '#57BFFA',
        '#46B8F9', // Small Conference
        '#40B6F9', // Custom Meeting Space
        '#2FB0F8',
        '#12A5F8', // Training Room
        '#08A1F7',
        '#0798EA', // Med Conference
        '#0688D2', // XL Conference
        '#0787D0',
        '#067ABC',
        '#0478B9', // Large Conference
        '#056DA8',
      ];
    case DEFAULT_AMENITY_SPACE_COLOR:
      return [
        '#FEF4F4',
        '#FDE8E8',
        '#FCDDDD',
        '#FBD1D1', // Fitness
        '#FAC6C6', // Wellness
        '#F9BBBB', // Pantry
        '#FFB9B9', // Meditation,
        '#F8AFAF',
        '#F7A4A4', // Break Room
        '#FB9F9F',
        '#F69898',
        '#F58D8D', // Custom Amenity Space
        '#FC8C8C',
        '#FD8686', // Library
        '#F48989', // Cafe
        '#F59393', // Game Room
        '#EE8F8F', // Mother's Room
        '#DD7F7F',
        '#C47171',
        '#AC6363',
      ];
    case DEFAULT_SUPPORT_SPACE_COLOR:
      return [
        '#F1FAF5',
        '#E2F5EA',
        '#D4F1E0', // Coat Closet
        '#CAF5DC',
        '#C5ECD5', // Reception Desk & Seating
        '#BBEDD0', // Copy/Print
        '#B2F4CE',
        '#A5ECC3', // Storage Room
        '#A9E2C1', // IT Tech Bar
        '#9ADDB6', // File Cabinets
        '#8CD9AC', // Janitorial Closet
        '#7DD4A1', // IDF
        '#70CF97', // Custom Support Spaces
        '#6FCF97', // ADA Bathroom
        '#51D889', // MDF
        '#33E07B', // Lockers
        '#49C27C', // Satellite Copy Area
        '#64BA88', // IT Storage Room
        '#59A679',
        '#478D64',
      ];
    default:
      return buildColorGradient(color);
  }
};

export const getColorUpdates = (category: Category, newColor: string) => {
  const updates: Record<string, unknown> = {
    [category]: newColor,
  };

  const categoryInCustomColorsParams = Object.keys(
    CATEGORY_CUSTOM_COLORS_PARAMS
  ).includes(category);

  if (!categoryInCustomColorsParams) {
    return updates;
  }

  const {
    swatchesRequired: swatchesRequireByCategory,
    categoryColorsKey,
  } = CATEGORY_CUSTOM_COLORS_PARAMS[category];
  const initialSwatchIndex = 4;
  // this range of swatches will be selected if the color selected by the use isn't a default color;
  const customColorSwatchesRange = [
    initialSwatchIndex,
    initialSwatchIndex + swatchesRequireByCategory,
  ];

  return {
    ...updates,
    [categoryColorsKey]: presetColorSwatchAvailable(newColor)
      ? prebuiltSelectedGradients(newColor).slice(0, swatchesRequireByCategory)
      : buildColorGradient(newColor).slice(...customColorSwatchesRange),
  };

  return updates;
};

export const BUILDING_VIEWS: Record<string, string> = {
  CURRENT_FLOOR: 'current_floor',
  DEPARTMENTS_AND_HEADCOUNTS: 'departments_and_headcounts',
  DEPARTMENTS_PROGRAMMING: 'departments_programming',
  BUILDING_OVERVIEW: 'building_overview',
};

export const PROGRAM_SUMMARY_VIEWS: Record<string, ProgramSummaryView> = {
  OCCUPANCY_AND_UTILIZATION: 'occupancy_and_utilization',
  PROGRAM_SUMMARY: 'program_summary',
  PROGRAMMING_SCENARIOS_INDEX: 'programming_scenarios_index',
};

export const STORAGE_LOCKER = 'storage_locker';

export const SPACE_NAME_MAP = {
  INDIVIDUAL_WORKSPACES: {
    WORKSTATION: WORKSTATION_TYPE,
    HOTEL_DESK: 'hotel_desk',
  },
  PRIVATE_OFFICES: {
    PRIVATE_OFFICE: 'private_office',
    SHARED_PRIVATE_OFFICE: 'shared_private_office',
    EXECUTIVE_PRIVATE_OFFICE: 'executive_private_office',
  },
  MEETING_SPACES: {
    PHONE_ROOM: 'phone_room',
    HUDDLE_ROOM: 'huddle_room',
    SMALL_CONFERENCE_ROOM: 'small_conference_room',
    MEDIUM_CONFERENCE_ROOM: 'medium_conference_room',
    LARGE_CONFERENCE_ROOM: 'large_conference_room',
    X_LARGE_CONFERENCE_ROOM: 'xlarge_conference_room',
    TRAINING_ROOM: 'training_room',
    MULTI_PURPOSE: 'multi_purpose',
    OPEN_COLLABORATIVE_SPACE: 'open_collaborative_space',
  },
  AMENITY_SPACES: {
    BREAK_ROOM: 'break_room',
    CAFE: 'cafe',
    FITNESS_ROOM: 'fitness_room',
    GAME_ROOM: 'game_room',
    LIBRARY: 'library',
    MEDITATION_ROOM: 'meditation_room',
    MOTHERS_ROOM: 'mothers_room',
    PANTRY: 'pantry',
    WELLNESS_ROOM: 'wellness_room',
  },
  SUPPORT_SPACES: {
    ADA_BATHROOM: 'ada_bathroom',
    COAT_CLOSET: 'coat_closet',
    COPY_PRINT_ROOM: 'copy_print_room',
    IDF: 'idf',
    IT_STORAGE_ROOM: 'it_storage_room',
    IT_TECH_BAR: 'it_tech_bar',
    JANITORIAL_CLOSET: 'janitorial_closet',
    LOCKERS: 'lockers',
    MDF: 'mdf',
    RECEPTION_DESK_SEATING: 'reception_desk_seating',
    SATELLITE_COPY_AREA: 'satellite_copy_area',
    STORAGE_ROOM: 'storage_room',
    STORAGE_LOCKER,
    FILE_CABINET: 'file_cabinet',
  },
};

export const WORKSHEET_MAP: Record<string, any> = {
  individualWorkspaces: {
    color: '#A967E8',
    title: 'Individual Workspaces',
  },
  workstations: {
    color: '#A967E8',
    title: 'Workstations',
  },
  privateOffices: {
    color: '#A967E8',
    title: 'Private Offices',
  },
  meetingSpaces: {
    color: '#40B6F9',
    title: 'Meeting Spaces',
  },
  amenitySpaces: {
    color: '#F58D8D',
    title: 'Amenity Spaces',
  },
  supportSpaces: {
    color: '#6fcf97',
    title: 'Support Spaces',
  },
  customCategory: {
    color: 'rgba(111, 207, 151, 0.6)',
    title: 'Custom Category',
  },
  storageCategory: {
    color: 'rgba(0,0,0,0)',
    title: '',
  },
};

export const SMALL_BUBBLES_CATEGORIES = [
  'hotel_desk',
  'workstation',
  'custom_workspace_type',
  'custom_workspace_type_child',
  'storage_locker',
  'file_cabinet',
];

export const FORGOT_PASSWORD = 'auth/password-reset';

export const NO_DATA_TO_SHOW = '--';

export const MACRO_PROGRAMMING_TYPE = 'macro-programming';
export const TOTAL_PROGRAM_TYPE = 'total-program';
export const TOTAL_PROGRAM_USF_TYPES = {
  sumLinkedScenarios: 'sum_linked_scenarios',
  totalProgramOnly: 'total_program_only',
};

export const GROWTH_CALCULATORS: { [key: string]: CalculatorType } = {
  buildingHeadcountSeatcount: 'building-headcount-seatcount',
  buildingHeadcountSeatcountDepartments:
    'building-headcount-seatcount-departments',
  floorHeadcountSeatcount: 'floor-headcount-seatcount',
  buildingUsf: 'building-usf',
  floorUsf: 'floor-usf',
  macroProgramming: MACRO_PROGRAMMING_TYPE,
  totalProgram: TOTAL_PROGRAM_TYPE,
};

export const CALCULATOR_TYPES = [
  {
    id: GROWTH_CALCULATORS.macroProgramming,
    label: 'Macro',
  },
  {
    id: GROWTH_CALCULATORS.buildingHeadcountSeatcountDepartments,
    label: 'Departments',
  },
  {
    id: GROWTH_CALCULATORS.buildingHeadcountSeatcount,
    label: 'Building Headcount & Seat Count',
  },
  {
    id: GROWTH_CALCULATORS.floorHeadcountSeatcount,
    label: 'Floor Headcount & Seat Count',
  },
  {
    id: GROWTH_CALCULATORS.buildingUsf,
    label: 'Building USF',
  },

  {
    id: GROWTH_CALCULATORS.floorUsf,
    label: 'Floor USF',
  },
];

export const SPACE_MODAL_TAB_INDEX = {
  details: 0,
  photos: 1,
  notes: 2,
  occupancy_and_utilization: 3,
};

export const NOTE_CHARACTER_LIMIT_NUMBER = 280;

export const DELETE_MESSAGES = { delete_space: 'DELETE SPACE' };

const PROGRAM_CALCULATIONS_LABELS = {
  total: 'Total Program USF',
  subtotal: 'Subtotal Program USF',
  totalAvailable: 'Total Available USF',
  programDelta: 'Program Delta USF',
};

export const getProgramCalculationLabels = (
  key: 'total' | 'subtotal' | 'totalAvailable' | 'programDelta'
) => {
  return PROGRAM_CALCULATIONS_LABELS[key];
};

export const getRsfProgramCalculationLabels = (
  key: 'total' | 'subtotal' | 'totalAvailable' | 'programDelta'
) => {
  return getProgramCalculationLabels(key).replace('USF', 'RSF');
};

export const TOTAL_AVAILABLE_USF_TITLE = {
  building: 'Total Available Building USF',
  floor: 'Total Available Floor USF',
};

export const FLOOR_CHARACTER_LIMIT = {
  programming: 12,
  existing_site_analysis: 15,
};

export const USER_NOT_FOUND = 'ApolloError: GraphQL error: User not found';
export const SESSION_SUPERSEDED = 'ApolloError: session_superseded';
export const SESSION_EXPIRED = 'ApolloError: session_expired';
export const NOT_AUTHENTICATED = 'ApolloError: not_authenticated';
export const INVALID_CREDENTIALS = 'The credentials entered are not valid.';

export const WORKSHEET_VALUES = {
  TARGET_RATIO: 'target_ratio',
  QUANTITY_OF_SPACE: 'quantity',
};

export const DEFAULT_SHARED_SPACES_FIELDS_TO_KEEP: {
  [spaceType: string]: IWorksheetRowValue;
} = [
  MEETING_SPACES_CATEGORY,
  AMENITY_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
].reduce(
  (acc, spaceType) => ({
    ...acc,
    [spaceType]: WORKSHEET_VALUES.TARGET_RATIO,
  }),
  {}
);

export const MAX_SEATCOUNT = 5000;
export const MAX_MANUALLY_ENTERED_SPACE_USF = 50000;
export const MAX_MANUALLY_ENTERED_FLOOR_USF = 100000;
export const MAX_MANUALLY_ENTERED_FLOOR_RSF =
  2 * MAX_MANUALLY_ENTERED_FLOOR_USF;
export const MIN_CURRENT_YEAR = 2000;
export const MAX_CURRENT_YEAR = 3000;
export const MAX_QTY = 99999;
export const MAX_SEAT_CAP = 5000;
export const MAX_DIM = 9999;
export const MAX_USF = 50000;
export const MAX_MACRO_HEADCOUNT = 99999;
export const MAX_GROWTH_TABLE_HC_INPUT = 20000;
export const MAX_BUILDING_USF = 999999999;
export const MAX_FLOOR_USF = 9999999;
export const MIN_GROWTH_TABLE_RATE_INPUT = -10;
export const MAX_GROWTH_TABLE_RATE_INPUT = 50;
export const MAX_DEPT_USF = 999999;
export const MAX_TOTAL_USF = 99999999;
export const MAX_MILLIMETERS_FOR_CALIBRATION = 999999;

export const MAX_SCENARIO_NAME_LENGTH = 22;
export const MAX_PROJECT_NUMBER_LENGTH = 22;

export const FILE_TYPES = {
  PDF: 'PDF',
  PNG: 'PNG',
  JPEG: 'JPEG',
};

export const MAX_SENTRY_PAYLOAD_SIZE = 200000; // 200kb https://develop.sentry.dev/sdk/event-payloads/
export const MAX_CATEGORY_NAME_LENGTH = 22;
export const MAX_SUB_CATEGORY_NAME_LENGTH = 18;

export enum REQUEST_STATUS {
  NONE,
  QUERYING,
  SUCCESS,
  FAILED,
}

export const DEFAULT_SPACE_TYPE_CATEGORIES: DefaultSpaceTypeCategory[] = [
  {
    category: INDIVIDUAL_WORKSPACES_CATEGORY,
    color: WORKSHEET_MAP.individualWorkspaces.color,
    name: WORKSHEET_MAP.individualWorkspaces.title,
    icon: 'individual-workspaces-icon',
  },
  {
    category: MEETING_SPACES_KEY,
    color: WORKSHEET_MAP.meetingSpaces.color,
    name: WORKSHEET_MAP.meetingSpaces.title,
    icon: 'meeting-spaces-icon',
  },
  {
    category: AMENITY_SPACES_KEY,
    color: WORKSHEET_MAP.amenitySpaces.color,
    name: WORKSHEET_MAP.amenitySpaces.title,
    icon: 'amenity-spaces-icon',
  },
  {
    category: SUPPORT_SPACES_KEY,
    color: WORKSHEET_MAP.supportSpaces.color,
    name: WORKSHEET_MAP.supportSpaces.title,
    icon: 'support-spaces-icon',
  },
];
export const TPS_CARDS_GUTTER = 16;

export const DEFAULT_AVATAR_IMG = '/images/user-avatar.svg';
export const NAME_TAKEN_MESSAGE = 'name: has already been taken\n';

export const USER_SEARCH_PLACEHOLDER_TEXT = 'Search by User Name';

export const PROJECT_TYPE_TO_PATH = {
  [EXISTING_SITE_ANALYSIS]: 'esa',
  [PROGRAMMING]: 'programming',
};

export const PROJECT_ROLES_TO_LABEL_MAP = {
  [UserRoleInProject.projectOwner]: 'Project Owner',
  [UserRoleInProject.editor]: 'Editor',
  [UserRoleInProject.viewer]: 'Viewer',
  [UserRoleInProject.orgAdmin]: 'Org Admin',
  [UserRoleInProject.teamAdmin]: 'Team Admin',
};

export const STANDARD_ERROR_MESSAGE =
  'The Wizard has been notified and is working on the issue.';

export const TEAM_NAME_TAKEN_FEEDBACK_MESSAGE = 'Team name is already in use.';

export const PROJECT_NAME_TAKEN_FEEDBACK_MESSAGE =
  'Project name is already in use.';

export const DRAFT_STATUS = 'draft';
export const BILLABLE_STATUS = 'billable';
export const TEMPLATE_STATUS = 'template';
export const BENCHMARK_STATUS = 'benchmark';

export const PROJECT_STATUS_OPTIONS: ProjectStatus[] = [
  DRAFT_STATUS,
  BILLABLE_STATUS,
  TEMPLATE_STATUS,
  BENCHMARK_STATUS,
];

export const XLSX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const SPW_DOMAIN = 'spaceplanwizard.com';

// https://emailregex.com/index.html
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const FLOOR_PAGE_PATH_REGEX = /\/projects\/esa\/\d+\/building\/\d+\/floor\/\d+/;

export const calculatorTypeToBreadcrumbName: {
  [key in CalculatorType]: string;
} = {
  'building-headcount-seatcount': 'Building Headcount & Seatcount',
  'building-headcount-seatcount-departments': 'Departments',
  'floor-headcount-seatcount': 'Floor Headcount & Seatcount',
  'building-usf': 'Building USF',
  'floor-usf': 'Floor USF',
  'macro-programming': 'Macro Programming',
  'total-program': 'Total Program',
};

export const getProgramCalculationTitle = (calculatorType: CalculatorType) => {
  if (calculatorType === 'macro-programming') {
    return 'MACRO PROGRAM';
  }

  if (
    [
      GROWTH_CALCULATORS.floorHeadcountSeatcount,
      GROWTH_CALCULATORS.floorUsf,
    ].includes(calculatorType)
  ) {
    return 'FLOOR PROGRAM';
  }

  if (
    [
      GROWTH_CALCULATORS.buildingUsf,
      GROWTH_CALCULATORS.buildingHeadcountSeatcount,
    ].includes(calculatorType)
  ) {
    return 'BUILDING PROGRAM';
  }

  if (
    calculatorType === GROWTH_CALCULATORS.buildingHeadcountSeatcountDepartments
  ) {
    return 'DEPARTMENT PROGRAM';
  }

  return 'TOTAL PROGRAM';
};

export const Z_INDEX_HIGHER_THAN_BREADCRUMBS = 102;
export const Z_INDEX_HIGHER_THAN_ALL_THE_LAYOUT = 1001;
export const TWO_TOOLBARS_ERROR_MESSAGE = 'Two toolbars at the same time';
export const CLIENT_NAMES_TOGGLE_CONTAINER_ID = 'client-names-toggle-container';

const PROJECT_YEARS_OPTIONS: string[] = [];

const CURRENT_YEAR = new Date().getFullYear();

for (let i = 2010; i < CURRENT_YEAR + 12; i++) {
  PROJECT_YEARS_OPTIONS.push(i.toString());
}

export { PROJECT_YEARS_OPTIONS };
